<template>
  <div id="app">
    <router-view keep-alive :thisuser="this.$parent.user" :personality="this.$parent.profile.personality" :favourites="this.$parent.profile.favourites"></router-view>
    <nav class="mobile-nav">
    	<ul>
          <li><router-link class="fg-type link-mobile-nav link-matches" to="/matches">Matches</router-link></li>
          <li><router-link class="fg-type link-mobile-nav link-everyone" to="/everyone">Everyone</router-link></li>
          <li><router-link class="fg-type link-mobile-nav link-chats notify" to="/chats">Chats</router-link></li>
          <li><router-link class="fg-type link-mobile-nav link-favourites" to="/favourites">Favourites</router-link></li>
        </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss" src="@/assets/sass/style.scss"></style>



// WEBPACK FOOTER //
// App.vue?036805f5